import { normalizeSearchResultsREST } from '../../helpers/formatters/formatters';

function buildResults( newResults, existingResults = [] ) {
	const allResults =
		0 < existingResults.length
			? existingResults.concat( normalizeSearchResultsREST( newResults ) )
			: normalizeSearchResultsREST( newResults );
	return allResults;
}

const removeDuplicateResults = ( results ) => {
	const cleanedResults = [];
	const existingIds = [];
	results.map( ( result ) => {
		if ( existingIds.includes( result.id ) ) return;
		existingIds.push( result.id );
		cleanedResults.push( result );
	} );
	return cleanedResults;
};

export const buildStateREST = ( fetchedData, state ) => {

	const {
		incrementPageRequest,
		selectedFilters,
		searchInputValue,
		searchIsEmpty,
	} = state;

	const { page, pages } = fetchedData;

	const totalMatches = 'number' === typeof( fetchedData.total )
		? fetchedData.total
		: null;

	const hasNextPage = page && pages && ( page < pages );

	const existingResults = Array.isArray( state.results )
		? state.results
		: [];

	const newResults = fetchedData?.posts && Array.isArray( fetchedData.posts )
		? fetchedData.posts
		: [];

	let results = incrementPageRequest
		? buildResults( newResults, existingResults )
		: buildResults( newResults );

	const featuredIDs = Array.isArray( fetchedData.featured )
		? fetchedData.featured
		: [];

	const existingFeaturedResults =  Array.isArray( state.featuredResults )
		? state.featuredResults
		: [];

	const newFeaturedResults = [];
	if ( 0 < featuredIDs.length ) {
		// Separate featured results into array
		featuredIDs.forEach( resultID => {
			const featuredPost = results.filter( result => {
				return result.id === resultID;
			} );
			if ( 'undefined' !== typeof featuredPost )
				newFeaturedResults.push( featuredPost[0] );
		} );
		// Remove featured results from main results
		results = results.filter( result => {
			return !featuredIDs.includes( result.id );
		} );
	}
	
	const featuredResults = incrementPageRequest ? existingFeaturedResults : newFeaturedResults;

	const featuredTitle = fetchedData?.featured_section_title
		? fetchedData.featured_section_title
		: null;

	// Remove duplicates in results
	results = removeDuplicateResults( results );

	const newSearchState = {
		results,
		page,
		hasNextPage,
		searchInputValue,
		selectedFilters,
		totalMatches,
		featuredResults,
		searchIsEmpty,
		featuredTitle,
	};

	// Copy new state for lastSuccessfulSearch
	const lastSuccessfulSearch = Object.assign( {}, newSearchState );
	lastSuccessfulSearch.incrementPageRequest = incrementPageRequest;
	
	return {
		...newSearchState,
		lastSuccessfulSearch,
	};

};
